import {
    CALENDAR_DAY_SLOT_COUNT,
    CALENDAR_DAY_SLOT_DURATION_MINUTES,
} from "../const/calendarDay";
import {
    createMoscowDayStart,
    createMoscowSlotDate,
    formatMoscowTime,
} from "./moscowDateTime";

export interface ICalendarDayVisibleRange {
    startIndex: number;
    endIndex: number;
    visibleStartsAt: Date;
    visibleEndsAt: Date;
}

interface ICalendarDayEventTime {
    startsAt: string;
    durationSlots: number;
}

export const formatCalendarDayTime = (date: Date): string => {
    return formatMoscowTime(date)
}

export const getCalendarDayStart = (date: Date): Date => {
    return createMoscowDayStart(date)
}

export const getCalendarDaySlots = (date: Date): Date[] => {
    return Array.from(
        {length: CALENDAR_DAY_SLOT_COUNT},
        (_, index) => createMoscowSlotDate(date, index)
    )
}

export const getCalendarSlotDateEnd = (
    startsAt: Date,
    durationSlots: number,
): Date => {
    return new Date(
        startsAt.getTime() +
        durationSlots * CALENDAR_DAY_SLOT_DURATION_MINUTES * 60 * 1000
    )
}

export const getCalendarEventTimeRange = (
    event: ICalendarDayEventTime,
    timeFormatter = formatCalendarDayTime,
): string => {
    const startsAt = new Date(event.startsAt)
    const endsAt = getCalendarSlotDateEnd(startsAt, event.durationSlots)

    return `${timeFormatter(startsAt)}–${timeFormatter(endsAt)}`
}

export const getCalendarDayVisibleRange = (
    visibleDate: Date,
    startsAt: string,
    durationSlots: number,
): ICalendarDayVisibleRange | null => {
    const dayStart = getCalendarDayStart(visibleDate)
    const dayEnd = new Date(
        dayStart.getTime() +
        CALENDAR_DAY_SLOT_COUNT * CALENDAR_DAY_SLOT_DURATION_MINUTES * 60 * 1000
    )
    const start = new Date(startsAt)
    const end = getCalendarSlotDateEnd(start, Math.max(durationSlots, 1))

    if(end <= dayStart || start >= dayEnd) return null

    const visibleStartsAt = start < dayStart ? dayStart : start
    const visibleEndsAt = end > dayEnd ? dayEnd : end
    const startIndex = Math.max(
        0,
        Math.floor(
            (visibleStartsAt.getTime() - dayStart.getTime()) /
            (CALENDAR_DAY_SLOT_DURATION_MINUTES * 60 * 1000)
        )
    )
    const endIndex = Math.min(
        CALENDAR_DAY_SLOT_COUNT,
        Math.ceil(
            (visibleEndsAt.getTime() - dayStart.getTime()) /
            (CALENDAR_DAY_SLOT_DURATION_MINUTES * 60 * 1000)
        )
    )

    if(endIndex <= startIndex) return null

    return {startIndex, endIndex, visibleStartsAt, visibleEndsAt}
}
